import { Space, List, Card, Typography, Row, Col, Descriptions, Statistic, Image, Select, Form, Flex } from "antd";
import CountUp from "react-countup";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { buscarTotalContaFinanceira } from "../../../services/painelGeralService";
import { useEffect } from "react";
import { buscarEmpresa } from "../../../services/empresaService";
import { EmpresaModel } from "../../../models/empresa/empresaModel";

const FinanceiroAuditoriaContabilPainel = (props: any) => {
  //estados globais
  const painelGeralState = useAppSelector((state) => state.painelGeral);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(buscarEmpresa(empresaState.busca));
  }, []);

  const formatter = (value: any) => <CountUp end={value} separator="." decimals={2} decimal="," />;

  const onChangeEmpresa = (value: number) => {
    dispatch(buscarTotalContaFinanceira(value));
  };

  return (
    <Flex vertical>
      {props.filtro && (
        <Form layout="vertical" style={{ marginLeft: "5px" }}>
          <Row gutter={12}>
            <Col>
              <Form.Item label="Empresa" name="empresa">
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="labelSearch"
                  placeholder="Selecione uma empresa"
                  loading={empresaState.loading}
                  onChange={onChangeEmpresa}
                  style={{ width: 300 }}
                  options={empresaState.list.map((a: EmpresaModel) => ({
                    value: a.id,
                    label: (
                      <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                        <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                        {a.apelido}
                      </Flex>
                    ),
                    labelSearch: a.apelido,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
      <Space wrap align="start" className="spaceFin" direction="vertical">
        <List
          grid={{ gutter: 16 }}
          dataSource={painelGeralState.list}
          className="listPainel listFin"
          renderItem={(item: any, index) => (
            <List.Item key={index}>
              <Card variant="borderless" className="cardPainel">
                <div className="gridPainel">
                  <Typography.Title level={4} className="textCardPainel">
                    {item.periodo}
                  </Typography.Title>
                  <Row gutter={12} className="rowunique">
                    <Col className="colPainel" span={props.contabil ? 24 : 12}>
                      <Descriptions title={`${props.titles[0]} (${item.quantidadePagar})`} layout="vertical" className="descriptionsPainel" colon={false}>
                        <Descriptions.Item label="TOTAL R$">
                          <Statistic title="" value={item.totalPagar} formatter={formatter} />
                        </Descriptions.Item>
                      </Descriptions>
                    </Col>
                    <Col className="colPainel" span={props.contabil ? 24 : 12}>
                      <Descriptions title={`${props.titles[1]} (${item.quantidadeReceber})`} layout="vertical" className="descriptionsPainel" colon={false}>
                        <Descriptions.Item label="TOTAL R$">
                          <Statistic title="" value={item.totalReceber} formatter={formatter} />
                        </Descriptions.Item>
                      </Descriptions>
                    </Col>
                    {props.contabil && (
                      <Col className="colPainel" span={props.contabil ? 24 : 12}>
                        <Descriptions title={`${props.titles[2]} (${item.quantidadePagarImposto})`} layout="vertical" className="descriptionsPainel" colon={false}>
                          <Descriptions.Item label="TOTAL R$">
                            <Statistic title="" value={item.totalPagarImposto} formatter={formatter} />
                          </Descriptions.Item>
                        </Descriptions>
                      </Col>
                    )}
                  </Row>
                </div>
              </Card>
            </List.Item>
          )}
        />
      </Space>
    </Flex>
  );
};

export default FinanceiroAuditoriaContabilPainel;
